/* eslint-disable max-len */
import { ReactElement } from 'react';
import { AccreditationEditListPropTypes } from 'src/types/propTypes/AccreditationEditListPropTypes';
import { IconType } from '../../types/propTypes/EmptyGridPropTypes';
import EmptyGridContent from '../EmptyGridContent/EmptyGridContent';
import './AccreditationEditList.css';

const AccreditationEditList = ({
  headerColumns,
  dataRows,
}: AccreditationEditListPropTypes): ReactElement => {
  return (
    <>
      {headerColumns && dataRows && (
        <table
          cellSpacing={0}
          className="page-view-table accreditation-edit-list"
        >
          <thead>
            <tr>
              {headerColumns.map((header) => (
                <th key={header.key} data-testid={`header-${header.key}`}>
                  {header.displayName}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {dataRows.map((row, index) => (
              <tr key={`row-${index}`} data-testid={`row-${index}`}>
                {headerColumns.map((header) => (
                  <td
                    key={`row-${index}-${header.key}`}
                    data-testid={`data-row-${header.key}-${index}`}
                  >
                    {row[header.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {(dataRows.length === 0 || headerColumns.length === 0) && (
        <EmptyGridContent iconType={IconType.FILE}>
          <p>There are currently no edits</p>
        </EmptyGridContent>
      )}
    </>
  );
};

export default AccreditationEditList;
